// components/Admin/Header.js
import React, { useState, useContext } from 'react';
import logo from '../../assets/logo-boost.svg'; // Импорт логотипа
import { IoLogOutOutline } from "react-icons/io5";
import { useNavigate } from 'react-router-dom';
import { useStores } from '../..';
import { Context } from '../../index';

import { logout } from '../../http/UserAPI';


const Header = () => {
  const { user } = useContext(Context)
  const navigate = useNavigate()
  const handleLogout = async () => {
    try {
      console.log("🚀 Выполняем выход пользователя...");

      await logout(user, navigate, null, null); // Передаем navigate в logout

      // ✅ Вызываем очистку данных пользователя
      user.clearUserData();

      console.log("✅ Пользователь успешно вышел!");

      // 🔄 Перенаправляем на страницу входа
      navigate('/');
    } catch (error) {
      console.error("❌ Ошибка при выходе:", error);
    }
  };
  return (
    <nav
      className="flex items-center justify-between flex-wrap bg-white-500 p-6 border-b border-gray-300"
      style={{ borderBottom: '1px solid #D1D5DB' }}
    >
      <div className="flex items-center flex-shrink-0 text-white mr-6">
        <img src={logo} alt="Логотип" width="90" height="20" />
        <span className="font-medium text-l tracking-tight ml-4 text-red-500">Админ-панель</span>
      </div>
      <div>
        <button onClick={handleLogout} type="button" className="h-[42px] bg-[#6446C3] text-white p-2 rounded-[12px] text-[16px] flex gap-1 items-center"> <IoLogOutOutline /> Выйти</button>
      </div>
    </nav>
  );
};

export default Header;
